export default __webpack_public_path__ + "static/media/ic_users.d3c40736.png";